// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"232":"96fc4ccf","266":"4d9105d2"}[chunkId] + ".chunk.js";
};